<div class="flex flex-col h-full overflow-hidden">
  <div class="flex-1 overflow-auto px-4 py-4">
    <div class="doc-markdown rounded border border-surface-200 bg-surface-50 p-6">
      <markdown [src]="mdSrc"></markdown>
    </div>
  </div>
  <div class="qb-page-footer">
    <button (click)="navigateBack()" pButton type="button" icon="pi pi-backward" label="Go Back"
      class="p-button-raised"></button>
  </div>
</div>
